import {DetailsFieldsSection} from '@/components/ui/details-atoms/DetailsAtoms'
import styled, {css} from 'styled-components'

export const StyledDetailsFieldsSection = styled(DetailsFieldsSection)(
    ({theme: {spacing}}) => css`
        & > .section-body {
            padding: ${spacing * 2}px ${spacing * 4}px ${spacing * 8}px ${spacing * 4}px;
        }
    `
)
